import React from 'react';
import { CloudUpload, FileText } from 'lucide-react';

interface FileDropZoneProps {
  file: File | null;
  isDragOver: boolean;
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileDropZone: React.FC<FileDropZoneProps> = ({
  file,
  isDragOver,
  onDrop,
  onDragOver,
  onDragLeave,
  onFileChange
}) => {
  return (
    <div
      onDrop={onDrop}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      className={`border-2 border-dashed rounded-xl p-3 transition-all duration-300 cursor-pointer ${isDragOver
        ? "border-[#0084CF] bg-gradient-to-br from-[#F2F8FC] to-[#E3F0F9] shadow-lg"
        : "border-gray-300 bg-gradient-to-br from-gray-50 to-gray-100 hover:border-[#0084CF] hover:shadow-md"
        }`}
    >
      <div className="text-center">
        <div className={`p-2 rounded-full mx-auto mb-1.5 w-12 h-12 flex items-center justify-center transition-all duration-300 ${isDragOver ? "bg-[#0084CF] shadow-lg scale-110" : "bg-white shadow-sm"
          }`}>
          <CloudUpload size={24} className={isDragOver ? "text-white" : "text-[#0084CF]"} />
        </div>

        <h3 className="text-sm font-bold text-gray-900 mb-1" style={{ fontWeight: 700 }}>
          {isDragOver ? "Drop your file here" : "Drag & Drop File"}
        </h3>

        <p className="text-[10px] text-gray-700 mb-2 font-bold" style={{ fontWeight: 700 }}>
          Or click below to browse and select your file (CSV, XLSX, or XLS)
        </p>

        {file && (
          <div className="bg-white border-2 border-[#0084CF] rounded-lg p-2 mb-2 inline-block shadow-sm">
            <div className="flex items-center gap-2 text-xs">
              <FileText size={14} className="text-[#0084CF]" />
              <span className="font-semibold text-gray-900 truncate max-w-[200px]">{file.name}</span>
              <span className="text-gray-500">({(file.size / 1024 / 1024).toFixed(2)} MB)</span>
            </div>
          </div>
        )}

        <input
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={onFileChange}
          className="hidden"
          id="file-upload"
        />
        <label
          htmlFor="file-upload"
          className="cursor-pointer inline-flex items-center gap-1.5 bg-[#0084CF] hover:bg-[#0066A3] text-white px-4 py-1.5 rounded-lg font-semibold text-xs transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
        >
          <FileText size={12} />
          Choose File
        </label>
      </div>
    </div>
  );
};

export default FileDropZone;
